import { type NextPageWithLayout } from 'next';
import { NoSSR } from '@/components';
import { getProductSidebarLayout } from '@/layout/ProductSidebarLayout';
import { FeaturedQuizPageView } from '@/module/featured/FeaturedQuizPageView';
import { getDefaultStaticProps } from '@/utils/next';
const FeaturedQuizPage: NextPageWithLayout = () => <NoSSR data-sentry-element="NoSSR" data-sentry-component="FeaturedQuizPage" data-sentry-source-file="index.page.tsx">
    <FeaturedQuizPageView data-sentry-element="FeaturedQuizPageView" data-sentry-source-file="index.page.tsx" />
  </NoSSR>;
FeaturedQuizPage.getLayout = function (page) {
  return getProductSidebarLayout(page, 'p-0', {
    hideMobileBottomNavigation: true,
    hideContentPaddingWithoutSidebar: true
  });
};
export default FeaturedQuizPage;
export const getStaticProps = getDefaultStaticProps;